import cn from 'classnames'
import { type ReactElement } from 'react'

interface ValueProps {
  additionalClasses?: string
  isSkipped: boolean
}

export default function FutureStatusCell ({ additionalClasses, isSkipped }: ValueProps): ReactElement {
  return (
    <div
      className={cn(
        'px-3 py-1 border rounded-full text-left',
        {
          'border-gray-300 bg-gray-100 text-gray-500': isSkipped,
          'border-wpy-blue-500 bg-wpy-blue-100 text-wpy-blue-500': !isSkipped
        },
        additionalClasses
      )}
    >
      {isSkipped ? 'Skipped' : 'Scheduled'}
    </div>
  )
}
